export enum ErrorKeys {
  EMAIL_ALREADY_IN_USE = 'EMAIL_ALREADY_IN_USE',
  NAME_ALREADY_IN_USE = 'NAME_ALREADY_IN_USE',
  ROLE_NAME_IN_USE = 'ROLE_NAME_IN_USE',
  TFA_ACTIVATION_REQUIRED = 'TFA_ACTIVATION_REQUIRED',
  TFA_NOT_VERIFIED = 'TFA_NOT_VERIFIED',
  INVALID_TFA_TOKEN = 'INVALID_TFA_TOKEN',
  LANE_ALREADY_EXISTS = 'LANE_ALREADY_EXISTS',
}
